export enum Action {
  LOADING,
  LOADED,
  SELECT_ALL,
  DESELECT_ALL,
  TOGGLE_SELECT,
  SET_TO_EDIT,
  SET_TO_DELETE,
  SET_FILTER,
  DELETE_ROWS,
  UPDATE_ROW,
  ADD_ROW,
  SET_SORT,
}
